/* eslint-disable react/jsx-no-useless-fragment */
import { ChangeEvent, useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg'
import { ReactComponent as LogoHapvidaIcon } from '../../assets/icons/logo-hapvida.svg'
import { appProfiles, useAuthContext } from '../../context/auth'
import { login, validateToken } from '../../service'
import { AppSelect } from '../appSelect'
import { DocInput, DocLabel } from '../form/styles'
import { PageTitle, SubTitle } from '../page/styles'
import { CloseButton, CloseIcon, LoginModalStyles } from './styles'
import { LoginModalPropTypes, LoginTypes } from './types'
import { isJsonString } from '../../utils'

export const LoginModal = ({
  show,
  callbackLogin,
  handleClose,
  layoutVariant = 'login',
  subtitle,
}: LoginModalPropTypes) => {
  const { host, setAuth, setAppKey, setTokenInfo } =
    useAuthContext()
  const navigate = useNavigate()

  const [payload, setPayload] = useState<LoginTypes>({
    profileCode: 0,
    host: 'hap',
    password: '',
    user: '',
  })
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isValid, setIsValid] = useState(true)

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setPayload((cur) => ({ ...cur, [target.name]: target.value }))
  }

  const handleSubmit = async () => {
    try {
      setIsLoading(true)

      const { data: loginData } = await login(payload)
      if (loginData.content.token) {
        const loginDataContent = loginData.content


        const { data: validationData } = await validateToken(loginDataContent?.token, payload.host)
        const validationDataContent = validationData.content

        sessionStorage.setItem('originType', 'bloodbank')
        sessionStorage.setItem('host', payload.host)
        sessionStorage.setItem('profileCode', payload?.profileCode?.toString() || '0')

        setAuth({ ...loginDataContent, dadosTokenBanco: 'bloodbank' })
        setTokenInfo(validationDataContent)
        toast.success('Login realizado com sucesso!')
        setIsLoading(false)
        navigate('/')
      } else {
        toast.error(loginData.content.message);
        setIsLoading(false);
      }

    } catch ({ response }) {
      if (response?.data?.content) {
        const msg = response?.data?.content
        toast.error(msg.mensagem)
      } else {
        toast.error('Falha na operação!')
      }
      setIsLoading(false)
    }
  }

  const handleSubmitStampLogin = async () => {
    try {
      setIsLoading(true)
      const codigoPerfil = sessionStorage.getItem('profileCode')

      const { data: loginData } = await login({
        ...payload,
        host,
        profileCode: parseInt(codigoPerfil, 10),
      })
      if (loginData.content.token) {
        const loginDataContent = isJsonString(loginData.content) ? JSON.parse(loginData.content) : loginData.content
        const { data: validationData } = await validateToken(loginDataContent?.token, payload.host)

        const validationDataContent = validationData.content

        toast.success('Autenticação realizado com sucesso!')
        setIsLoading(false)
        callbackLogin(validationDataContent)
        setPayload({
          profileCode: parseInt(codigoPerfil, 10),
          host: 'hap',
          password: undefined,
          user: undefined,
        })
      } else {
        toast.error(loginData.content.message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false)
      if (error.response?.data?.content) {
        const msg = JSON.parse(error.response?.data?.content)
        toast.error(msg.mensagem)
      } else {
        toast.error('Falha na operação!')
      }
    }
  }

  function handleButtonSubmit() {
    return layoutVariant === 'stamp-login' ? handleSubmitStampLogin() : handleSubmit()
  }

  function handleEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.code === 'Enter' && !isLoading && isValid) {
      handleButtonSubmit();
    }

  }

  const handleCloseFlow = () => {
    setPayload({
      profileCode: 3,
      host,
      password: '',
      user: '',
    })

    handleClose()
  }

  useEffect(() => {
    const codigoPerfil = sessionStorage.getItem('profileCode')

    setPayload((pay) => ({
      ...pay,
      profileCode: parseInt(codigoPerfil || '0', 10),
    }))
  }, [])

  useEffect(() => {
    let tempCount = 0
    Object.values(payload)?.forEach((item) => {
      if (item) {
        tempCount += 1
      }
    })

    if (payload?.host) {
      setAppKey(`${payload?.host}-BSA005`)
    }

    setIsValid(tempCount === 4)
  }, [payload])

  return (
    <LoginModalStyles
      layoutVariant={layoutVariant}
      show={show}
      onHide={layoutVariant === 'stamp-login' ? handleClose : null}
    >
      {layoutVariant === 'stamp-login' ? (
        <Modal.Header>
          <div className='d-flex justify-content-end w-100'>
            <CloseButton variant='light' onClick={handleCloseFlow}>
              <CloseIcon />
            </CloseButton>
          </div>
        </Modal.Header>
      ) : null}
      <Modal.Body>
        {layoutVariant === 'stamp-login' ? (
          <div className='logo-wrapper'>
            <SubTitle style={{ color: '#4F4F4F', fontWeight: 400, fontSize: 12 }}>
              {subtitle || 'Usuário responsável pela coleta'}
            </SubTitle>
            <PageTitle
              style={{ textTransform: 'uppercase', textAlign: 'center', color: '#4F4F4F' }}
            >
              Identifique-se
            </PageTitle>
          </div>
        ) : (
          <div className='logo-wrapper'>
            <LogoHapvidaIcon />
            <PageTitle style={{ textTransform: 'uppercase', textAlign: 'center', fontSize: 12 }}>
              Sistema de Gestão de Banco de Sangue
            </PageTitle>
          </div>
        )}

        {layoutVariant === 'stamp-login' ? null : (
          <>
            <div>
              <Form.Check
                inline
                label='Demais Filiais'
                name='host'
                type='radio'
                id='inline-radio-2'
                className='fs-13'
                value='hap'
                checked={payload.host === 'hap'}
                onChange={handleChange}
              />
              <Form.Check
                inline
                label='Unidade Recife'
                name='host'
                type='radio'
                id='inline-radio-1'
                className='fs-13'
                value='schosp'
                checked={payload.host === 'schosp'}
                onChange={handleChange}
              />
            </div>
            <hr />
            <DocLabel>Código do Perfil:</DocLabel>
            <AppSelect
              options={[{ label: 'Selecione perfil', value: '0', disabled: true }, ...appProfiles]}
              name='profileCode'
              value={payload.profileCode}
              onChange={handleChange}
            />
          </>
        )}

        <DocLabel htmlFor='login'>Nome de Usuário:</DocLabel>
        <DocInput
          type='text'
          name='user'
          className='modal-input text'
          placeholder='Login'
          onChange={handleChange}
        />
        <div className='modal-input-wrapper'>
          <DocLabel htmlFor='password'>Senha:</DocLabel>
          <DocInput
            type={showPassword ? 'text' : 'password'}
            name='password'
            className='modal-input password'
            placeholder='Senha'
            onChange={handleChange}
            onKeyUp={(e) => handleEnter(e)}
          />
          <button
            type='button'
            className='modal-input-btn'
            onClick={() => setShowPassword((cur) => !cur)}
          >
            <EyeIcon />
          </button>
        </div>
        {layoutVariant !== 'stamp-login' ? (
          <Row>
            <Col style={{ textAlign: 'right', marginBottom: 20 }}>
              <a
                target='_blank'
                href='https://portaldeservicos.hapvida.com.br'
                className='recover-pw'
                rel='noreferrer'
              >
                Esqueceu a Senha?
              </a>
            </Col>
          </Row>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          disabled={isLoading || !isValid}
          className='login-btn'
          onClick={() => handleButtonSubmit()}
        >
          {isLoading && <Spinner animation='border' size='sm' variant='light' />}
          {!isLoading && layoutVariant !== 'stamp-login' && 'Entrar'}
          {!isLoading && layoutVariant === 'stamp-login' && 'Efetuar Login'}
        </Button>
      </Modal.Footer>
    </LoginModalStyles>
  )
}
